var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site-status-banner-container"},[_c('div',{staticClass:"status-banner-content"},[_vm._v(" "+_vm._s(_vm.$t('global.title.sandboxSite'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }